import { axios } from './commons';

// {
//   "service": "live-feed",
//   "id": "awfawf",
// },

const orderApiBrokerList = (brokers = []) => {
  const brokerServices = [];

  brokers.forEach((broker) => {
    brokerServices.push(`order-api:${broker}`);
  });

  return brokerServices;
};

const servicesList = (services = []) => {
  const servicesList = [];

  services.forEach(({ service, id }) => {
    servicesList.push(`${service}:${id}`);
  });

  return servicesList;
};

export default {
  getHealthStatus: (brokers = [], services = []) => {
    const servicesCombo = [
      ...orderApiBrokerList(brokers),
      'live-feed',
      ...servicesList(services),
    ];

    return axios.post('/system/health-status', {
      services: servicesCombo,
    });
  },
};
